import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Loading from "../../../components/Loading";
import Data from '../../../../repository';
import styles from '../../../../styles/Admin.module.scss';

function UpdateWalletPackageForm() {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [serverError, setServerError] = useState(null);
	const [form, setForm] = useState({
		_id: id,
		name: '',
		description: '',
		purchaseAmount: '',
		creditAmount: '',
		enabled: true,
		archived: false,
		sortOrder: 0
	});

	useEffect(() => {
		const loadPackage = async () => {
			try {
				const result = await Data.fetchWalletPackage(id);
				const walletPackage = result.data;
				setForm({
					_id: walletPackage._id,
					name: walletPackage.name || '',
					description: walletPackage.description || '',
					purchaseAmount: walletPackage.purchaseAmount || '',
					creditAmount: walletPackage.creditAmount || '',
					enabled: walletPackage.enabled,
					archived: walletPackage.archived,
					sortOrder: walletPackage.sortOrder || 0
				});
			} catch (error) {
				setServerError('Failed to load wallet package.');
			} finally {
				setLoading(false);
			}
		};

		loadPackage();
	}, [id]);

	const onSubmit = async (event) => {
		event.preventDefault();
		setSubmitting(true);
		setServerError(null);

		try {
			await Data.updateWalletPackage({
				...form,
				purchaseAmount: Number(form.purchaseAmount),
				creditAmount: Number(form.creditAmount),
				sortOrder: Number(form.sortOrder || 0),
				enabled: !!form.enabled,
				archived: !!form.archived
			});
			navigate("/admin/wallet-packages");
		} catch (error) {
			setServerError(error.response?.data?.message || 'Failed to update wallet package.');
			setSubmitting(false);
		}
	};

	if (loading) return <Loading button={false} />;

	return (
		<form onSubmit={onSubmit} className={styles.form}>
			<div>
				<p>Name: *</p>
				<input type="text" value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} required />
			</div>

			<div>
				<p>Description:</p>
				<input type="text" value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} />
			</div>

			<div>
				<p>Customer Pays - in pence: *</p>
				<input type="number" value={form.purchaseAmount} onChange={(event) => setForm({ ...form, purchaseAmount: event.target.value })} required />
			</div>

			<div>
				<p>Wallet Credit - in pence: *</p>
				<input type="number" value={form.creditAmount} onChange={(event) => setForm({ ...form, creditAmount: event.target.value })} required />
			</div>

			<div>
				<p>Sort Order:</p>
				<input type="number" value={form.sortOrder} onChange={(event) => setForm({ ...form, sortOrder: event.target.value })} />
			</div>

			<div>
				<p>Status:</p>
				<select value={form.enabled ? 'true' : 'false'} onChange={(event) => setForm({ ...form, enabled: event.target.value === 'true' })}>
					<option value="true">Enabled</option>
					<option value="false">Disabled</option>
				</select>
			</div>

			{serverError ? <p style={{ color: 'red' }}>{serverError}</p> : null}

			<button type="submit" className="btn btnPrimary" disabled={submitting}>
				{submitting ? <Loading button={true} /> : 'Save Changes'}
			</button>
		</form>
	);
}

export default UpdateWalletPackageForm;
